import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Zap } from 'lucide-react';
import TopBar from '@/components/TopBar';
import SidebarContent from '@/components/SidebarContent';

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      <TopBar />

      {/* Desktop Sidebar */}
      <aside
        data-testid="desktop-sidebar"
        className="hidden lg:flex fixed top-0 left-0 w-64 h-full border-r border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 z-30 flex-col"
      >
        {/* Sidebar Logo */}
        <div className="h-14 flex items-center px-4 border-b border-slate-200 dark:border-slate-800 flex-shrink-0">
          <Link
            to="/"
            data-testid="sidebar-logo"
            className="flex items-center gap-2.5"
          >
            <div className="w-7 h-7 rounded-md bg-teal-600 flex items-center justify-center flex-shrink-0">
              <Zap className="h-4 w-4 text-white" />
            </div>
            <div>
              <p className="font-semibold text-slate-900 dark:text-white text-sm leading-none font-heading">
                Learn Power Systems
              </p>
            </div>
          </Link>
        </div>

        {/* Sidebar Navigation */}
        <div className="flex-1 overflow-y-auto">
          <SidebarContent currentPath={location.pathname} />
        </div>
      </aside>

      {/* Main Content */}
      <main className="lg:ml-64 pt-14 min-h-screen">
        {children}
      </main>
    </div>
  );
};

export default Layout;
